// frontend/src/pages/index.js
export { default as Login } from "./Login";
export { default as Dashboard } from "./Dashboard";
export { default as Profile } from "./Profile";
export { default as AdminPanel } from "../components/admin/Dashboard";
